import Emitter from './emitter';

type MarketingTrackingEmitterEventData = {
  event: string;
  payload: Record<string, unknown>;
};
const marketingTrackingEmitter =
  new Emitter<MarketingTrackingEmitterEventData>();

export const MarketingTrackingEmitterEventType = 'sendMarketingTrackingEvent';

const marketingTrackingEmitterEvent = {
  emit: (data: MarketingTrackingEmitterEventData) => {
    marketingTrackingEmitter.emit(MarketingTrackingEmitterEventType, data);
  },
};

export { marketingTrackingEmitter, marketingTrackingEmitterEvent };
